"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const typography_1 = require("@alfalab/core-components/typography");
const Text = ({ text, componentSize, colorText }) => {
    if (Number(componentSize) >= 80) {
        return ((0, jsx_runtime_1.jsx)(typography_1.Typography.Title, { view: 'small', tag: 'div', color: colorText, children: text }));
    }
    if (Number(componentSize) === 64) {
        return ((0, jsx_runtime_1.jsx)(typography_1.Typography.Text, { view: 'primary-large', weight: 'bold', color: colorText, children: text }));
    }
    return ((0, jsx_runtime_1.jsx)(typography_1.Typography.Text, { view: 'primary-small', weight: 'bold', color: colorText, children: text }));
};
exports.Text = Text;
